export const programTypeClassShort = {
  'Micro-credential/Badge': 'Microcredential',
  'Professional Degree': 'Professional',
  'Associate Degree': 'Associate',
  'Bachelor Degree': 'Bachelor',
  'Master Degree': 'Master',
  'Doctoral Degree': 'Doctoral',
  'Postbaccalaureate Certificate': 'Postbaccalaureate Cert'
} as const;
